export default __webpack_public_path__ + "static/media/weirdlythistiesintoanactualcanonthing_so_horsehoes.ce5e7353.PNG";